var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.uniqueKey,staticClass:"rich-wrapper",style:({
    width: _vm.config.chartWidth +'px',
    height: _vm.config.chartHeight +'px',
    fontSize: '22px',
  })},[_c('div',{ref:"editable"})])
}
var staticRenderFns = []

export { render, staticRenderFns }